import { useContext } from 'react';
import { BrandContext } from '../../providers/BrandProvider';

export interface UserBrandReturn {
  secondaryColor: string;
}

export default function useBrand(): UserBrandReturn {
  const brandObject = useContext(BrandContext) as UserBrandReturn;
  if (!brandObject) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return brandObject;
}
